<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Services
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Helpers
	import { real_id } from 'src/helpers/interface_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Stores
	//Design system components
	import { Container, Toggle } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from 'src/types/Device';
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	//Svelte hooks
	import { onMount } from 'svelte';

	$: settingsStore = getDeviceSettings(id);
	export let device: Device;

	let inputsSettings = {};
	let id = real_id(device.id),
		settings = $settingsStore,
		loading = {},
		cache;

	const getSettings = () => {
		Object.keys(settings).forEach((setting) => {
			if (setting.includes('input:') && Number(setting.split(':')[1]) < 100) {
				inputsSettings[setting.split(':')[1]] = settings[setting].enable;
				loading[setting.split(':')[1]] = false;
			}
		});
		cache = Object.assign({}, inputsSettings);
	};

	const sentRequest = async (inputChannel, event) => {
		inputsSettings[inputChannel] = event.target.checked;
		if (cache[inputChannel] !== inputsSettings[inputChannel]) {
			loading[inputChannel] = true;
			const res: SettingRequest = await gen2Request(device, 'Input.SetConfig', {
				id: inputChannel,
				config: { enable: inputsSettings[inputChannel] },
			});

			const response = onSettingsResponse(res, device);
			if (response) {
				settings[`input:${inputChannel}`].enable = inputsSettings[inputChannel];
				devices_settings.update_devices_settings(id, settings);
				cache = Object.assign({}, inputsSettings);
			} else {
				inputsSettings = Object.assign({}, cache);
			}
			loading[inputChannel] = false;
		}
	};

	onMount(() => {
		getSettings();
	});
</script>

{#each Object.keys(inputsSettings) as _, i}
	<Container padding="xs" class="mb-s">
		<Toggle
			checked={inputsSettings[i]}
			disabled={loading[i]}
			on:click={(e) => sentRequest(i, e)}
			size="m"
			id="toggle-xoyptpq"
			>{$format('input_enable_desc_per_id', {
				default: `Enable input ${settings[`input:${i}`].name || i}`,
				values: { index: settings[`input:${i}`].name || i },
			})}</Toggle
		>
	</Container>
{/each}
